import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './PopupModel.css'; // Import custom styles

const PopupModal = ({ show, onClose, data }) => {
  if (!data) return null;

  let ruleDetails = [];
  try {
    ruleDetails =
      typeof data.rule_details === 'string'
        ? JSON.parse(data.rule_details)
        : Array.isArray(data.rule_details)
        ? data.rule_details
        : [];
  } catch (error) {
    console.error('Failed to parse rule_details:', error);
  }
  console.log(data);
  return (
    <div
      className={`modal fade custom-modal ${show ? 'show d-block' : ''}`}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Candidate Result Details</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <table className="table table-bordered mb-4">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{data.name}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{data.email}</td>
                </tr>
                <tr>
                  <th>Total Questions</th>
                  <td>{data.total_questions}</td>
                </tr>
                <tr>
                  <th>Correct Answers</th>
                  <td>{data.correct_answers}</td>
                </tr>
                <tr>
                  <th>Score</th>
                  <td>{data.score}</td>
                </tr>
                <tr>
                  <th>Over All Result:</th>
                  <td className={data.status === 'Passed' ? 'text-success' : 'text-danger'}>
                    <span className={`badge ${data.status === 'Passed' ? 'bg-success' : 'bg-danger'}`}>
                      {data.status}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <h6 className="mb-3">Category-wise Breakdown</h6>
            {ruleDetails.length > 0 ? (
              ruleDetails.map((rule, index) => (
                <div key={index} className="rule-box mb-3">
                   <h6 className="mb-2 text-primary">{rule.category}</h6>
                  <ul className="mb-0">
                    <li><strong>Total Questions:</strong> {rule.totalQuestions}</li>
                    <li><strong>Correct Answers:</strong> {rule.correctAnswers}</li>
                    <li>
          <strong className="text-warning">Minimum Required to Pass:</strong>{' '}
          <span className="badge bg-warning text-dark">{rule.minCorrect}</span>
        </li>
        <li>
          <strong>Status:</strong>{' '}
          <span className={`badge ${rule.passed ? 'bg-success' : 'bg-danger'}`}>
            {rule.passed ? 'Passed' : 'Failed'}
          </span>
        </li>
        <li className={`mt-2 small ${rule.passed ? 'text-success' : 'text-danger'}`}>
          {rule.passed
            ? `✅ You met the requirement by scoring ${rule.correctAnswers} correct answer${rule.correctAnswers > 1 ? 's' : ''}.`
            : `❌ You needed at least ${rule.minCorrect} correct answer${rule.minCorrect > 1 ? 's' : ''}, but got only ${rule.correctAnswers}.`}
        </li>
                    
                  </ul>
                </div>
              ))
            ) : (
              <div className="text-muted">No rule details available</div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
